import { api } from '@/lib/axios';

export interface WhatsAppStatus {
  service: {
    enabled: boolean;
    instance: string;
    provider: string;
    baseUrl: string;
  };
  connection: {
    connected: boolean;
    instance: string;
    phoneNumber?: string;
    profileName?: string;
    status?: string;
  };
}

export interface QRCodeResponse {
  qrcode?: string;
  base64?: string;
  instance: string;
  message?: string;
}

export interface SendTextDto {
  number: string;
  text: string;
  delay?: number;
  linkPreview?: boolean;
}

export interface WhatsAppResponse {
  success: boolean;
  messageId?: string;
  error?: string;
  data?: any;
}

const whatsappService = {
  // Status e Conexão
  async getStatus(): Promise<WhatsAppStatus> {
    const response = await api.get('/whatsapp/status');
    return response.data;
  },

  async connectInstance(): Promise<QRCodeResponse> {
    const response = await api.get('/whatsapp/instance/connect');
    return response.data;
  },

  async getQRCode(): Promise<QRCodeResponse> {
    const response = await api.get('/whatsapp/instance/qrcode');
    return response.data;
  },

  async createInstance(instanceName?: string): Promise<WhatsAppResponse> {
    const response = await api.post('/whatsapp/instance/create', {
      instanceName
    });
    return response.data;
  },

  async logout(): Promise<WhatsAppResponse> {
    const response = await api.delete('/whatsapp/instance/logout');
    return response.data;
  },

  async getProfile(): Promise<any> {
    const response = await api.get('/whatsapp/profile');
    return response.data;
  },

  // Envio de Mensagens
  async sendText(data: SendTextDto): Promise<WhatsAppResponse> {
    const response = await api.post('/whatsapp/send/text', data);
    return response.data;
  },

  async sendMedia(data: any): Promise<WhatsAppResponse> {
    const response = await api.post('/whatsapp/send/media', data);
    return response.data;
  },

  async sendButtons(data: any): Promise<WhatsAppResponse> {
    const response = await api.post('/whatsapp/send/buttons', data);
    return response.data;
  },

  async sendList(data: any): Promise<WhatsAppResponse> {
    const response = await api.post('/whatsapp/send/list', data);
    return response.data;
  },

  async sendContact(data: any): Promise<WhatsAppResponse> {
    const response = await api.post('/whatsapp/send/contact', data);
    return response.data;
  },

  async sendLocation(data: any): Promise<WhatsAppResponse> {
    const response = await api.post('/whatsapp/send/location', data);
    return response.data;
  },

  async sendBroadcast(data: any): Promise<any> {
    const response = await api.post('/whatsapp/send/broadcast', data);
    return response.data;
  },

  // Verificações
  async checkNumber(number: string): Promise<{ number: string; hasWhatsApp: boolean }> {
    const response = await api.post('/whatsapp/check-number', { number });
    return response.data;
  },
};

export default whatsappService;